/**
 * Helpers for a driver's type.
 *
 * A driver record stores the raw type ("COMPANY DRIVER", "LEASE OPERATOR", "OWNER OPERATOR",
 * "NON-AVATAR DRIVER"). These helpers turn it into the label the dispatch pages, the drivers list
 * and the breakdown dashboard show, so every page names a driver's type the same way.
 */

const DRIVER_TYPE_LABELS: { [type: string]: string } = {
  "COMPANY DRIVER": "Company Driver",
  // A lease operator drives a leased truck, so they are shown as a company driver.
  "LEASE OPERATOR": "Company Driver",
  "OWNER OPERATOR": "Owner Operator",
  "NON-AVATAR DRIVER": "Non-Avatar Driver",
};

/**
 * The label for a driver type ("LEASE OPERATOR" -> "Company Driver"). An unknown type is title
 * cased ("SOME_TYPE" -> "Some Type"); an empty type gives an empty label.
 */
export function getDriverTypeLabel(type?: string | null): string {
  const raw = (type ?? "").trim();
  if (!raw) return "";

  const known = DRIVER_TYPE_LABELS[raw.toUpperCase()];
  if (known) return known;

  return raw
    .split(/[\s_]+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
